import script from "./AnalyticsTabStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsTabStrip.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsTabStrip.vue?vue&type=style&index=0&id=007ecff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-007ecff6"]])

export default __exports__